import { transformServerTimePricing } from 'features/timesPrice';

import { UpdateCoachParams } from '../store/types';

interface Props extends Omit<UpdateCoachParams, 'id'> {
  id?: number;
}

export const transformCouchInfo = ({ metainfo, imageId, ...req }: Props) => ({
  ...req,
  'image_id': imageId,
  metainfo: metainfo && {
    pricing: transformServerTimePricing(metainfo.pricing),
    description: metainfo.description,
    rating: metainfo.rating
  }
});
